import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const ExperiencesIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        d="M0.955 1.91C1.48243 1.91 1.91 1.48243 1.91 0.955C1.91 0.427568 1.48243 0 0.955 0C0.427568 0 0 0.427568 0 0.955C0 1.48243 0.427568 1.91 0.955 1.91Z"
        fill="currentColor"
      />
      <path
        d="M0.955 15.2798C1.48243 15.2798 1.91 14.8522 1.91 14.3248C1.91 13.7974 1.48243 13.3698 0.955 13.3698C0.427568 13.3698 0 13.7974 0 14.3248C0 14.8522 0.427568 15.2798 0.955 15.2798Z"
        fill="currentColor"
      />
      <path
        d="M14.3258 15.2798C14.8533 15.2798 15.2808 14.8522 15.2808 14.3248C15.2808 13.7974 14.8533 13.3698 14.3258 13.3698C13.7984 13.3698 13.3708 13.7974 13.3708 14.3248C13.3708 14.8522 13.7984 15.2798 14.3258 15.2798Z"
        fill="currentColor"
      />
      <path
        d="M14.3258 1.91C14.8533 1.91 15.2808 1.48243 15.2808 0.955C15.2808 0.427568 14.8533 0 14.3258 0C13.7984 0 13.3708 0.427568 13.3708 0.955C13.3708 1.48243 13.7984 1.91 14.3258 1.91Z"
        fill="currentColor"
      />
      <path
        d="M2.86417 9.55021C3.91903 9.55021 4.77417 8.69507 4.77417 7.64021C4.77417 6.58534 3.91903 5.73021 2.86417 5.73021C1.8093 5.73021 0.954167 6.58534 0.954167 7.64021C0.954167 8.69507 1.8093 9.55021 2.86417 9.55021Z"
        fill="currentColor"
      />
      <path
        d="M7.63917 14.3252C8.69403 14.3252 9.54917 13.4701 9.54917 12.4152C9.54917 11.3603 8.69403 10.5052 7.63917 10.5052C6.5843 10.5052 5.72917 11.3603 5.72917 12.4152C5.72917 13.4701 6.5843 14.3252 7.63917 14.3252Z"
        fill="currentColor"
      />
      <path
        d="M12.4142 9.55021C13.469 9.55021 14.3242 8.69507 14.3242 7.64021C14.3242 6.58534 13.469 5.73021 12.4142 5.73021C11.3593 5.73021 10.5042 6.58534 10.5042 7.64021C10.5042 8.69507 11.3593 9.55021 12.4142 9.55021Z"
        fill="currentColor"
      />
      <path
        d="M7.63917 4.77521C8.69403 4.77521 9.54917 3.92007 9.54917 2.86521C9.54917 1.81034 8.69403 0.955208 7.63917 0.955208C6.5843 0.955208 5.72917 1.81034 5.72917 2.86521C5.72917 3.92007 6.5843 4.77521 7.63917 4.77521Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
